import React from 'react';

import PropTypes from 'prop-types';

import { LabelRadiobutton } from 'components/LabelRadiobutton/LabelRadiobutton';

import { DEBExpertQualificationSection } from './DEBExpertQualificationSection';

import './DEBExpertPopupMainBranchSection.sass';

export const DEBExpertPopupMainBranchSection = ({
  formik,
  installerStatusSummary,
  firstQualificationGasItems,
  firstQualificationEnergyItems,
}) => (
  <>
    <div className="popup-content__popup-checboxes">
      <div className="flex-col">
        <div className="primary-text-color">
          Die verantwortliche Fachkraft ist Inhaber/Geschäftsführer*?
        </div>
        <div className="flex-row">
          <LabelRadiobutton
            label="Nein"
            name="isExpertOwner"
            id="isExpertOwner"
            error={Boolean(formik.errors.isExpertOwner)}
            value={false}
            checked={formik.values.isExpertOwner === false}
            onChange={formik.handleChange}
          />
          <LabelRadiobutton
            label="Ja"
            name="isExpertOwner"
            id="isExpertOwner"
            error={Boolean(formik.errors.isExpertOwner)}
            value
            checked={formik.values.isExpertOwner === true}
            onChange={formik.handleChange}
          />
        </div>
      </div>
    </div>
    <DEBExpertQualificationSection
      formik={formik}
      installerStatusSummary={installerStatusSummary}
      firstQualificationGasItems={firstQualificationGasItems}
      firstQualificationEnergyItems={firstQualificationEnergyItems}
    />
  </>
);

DEBExpertPopupMainBranchSection.propTypes = {
  formik: PropTypes.object.isRequired,
  installerStatusSummary: PropTypes.object.isRequired,
  firstQualificationGasItems: PropTypes.array.isRequired,
  firstQualificationEnergyItems: PropTypes.array.isRequired,
};
